<script>
    import {brushModeStore as mode,
        brushSizeStore as size,
        brushShapeStore as shape,
        rotationStore as rotation,
        activeTextureStore,
        zoomStore as zoom,
        hsvHStore,
        hsvSStore,
        hsvVStore} from "./gp-context-texture.js";
    import OptionButtons from './gp-optionbuttons.svelte';
    import {GPMisc} from "./gp-misc";
    import {getGPTransFunc} from "./gp-translations";

    let trans = getGPTransFunc("gp-texturepicker");

    export let hsvAdjuster;
    let hsvSupported = GPMisc.detectBrowser() !== "safari" && !GPMisc.iOS();

    $: {
        if ($activeTextureStore) {
            hsvAdjuster.resetAdjustment();
            hsvAdjuster.close();
        }
    }

    let brushes = [
        {val : "optionBrush", icon: "fa-paint-brush", title: trans('Painting')},
        {val : "optionEraser", icon: "fa-eraser", title: trans('Erasing')}
    ];
    let brushShapes = [
        {val : "optionSquare", icon: "fa-square", title: trans('Square brush')},
        {val : "optionCircle", icon: "fa-circle", title: trans('Circle brush')}
    ];
    $: sizes = $shape === "optionCircle" ? [
        {val : "optionBrush1", icon: "fa-circle", title: trans('Small brush')},
        {val : "optionBrush2", icon: "fa-circle", title: trans('Medium brush')},
        {val : "optionBrush3", icon: "fa-circle", title: trans('Big brush')}
    ] : [
        {val : "optionBrush1", icon: "fa-square", title: trans('Small brush')},
        {val : "optionBrush2", icon: "fa-square", title: trans('Medium brush')},
        {val : "optionBrush3", icon: "fa-square", title: trans('Big brush')}
    ]

    function adjustHSV() {
        let initialHSV = {h: 0, s: 0, v: 0};

        let throttle = null;

        let updater = (ph, ps, pv) => {
            if (throttle) clearTimeout(throttle);
            throttle = setTimeout(() => {
                $hsvHStore = ph;
                $hsvSStore = ps;
                $hsvVStore = pv;
            },100)
        };
        hsvAdjuster.getHSV(initialHSV, updater);
    }

    function resetValues() {
        $mode = "optionBrush";
        $size = "optionBrush2";
        $shape = "optionSquare";
    }
</script>

<svelte:window on:GPNewProject={resetValues}/>

<div class="GPTextureSearchButtons GPSearchButtons">
    <OptionButtons bind:value={$shape} bind:values={brushShapes}/>
    <OptionButtons bind:value={$size} values={sizes}/>
    <OptionButtons bind:value={$mode} values={brushes}/>
    {#if (!$activeTextureStore.fullscreen)}
    <div class="btn-group btn-group-xs " role="group">
        <a href="#" tabindex="0" class="btn btn-default" on:click={() => $rotation += Math.PI/24} title={trans("Rotate texture left")}><i class="fas fa-undo"></i></a>
        <a href="#" tabindex="0" class="btn btn-default" on:click={() => $rotation -= Math.PI/24} title={trans("Rotate texture right")}><i class="fas fa-redo"></i></a>
    </div>
    <div class="btn-group btn-group-xs " role="group">
        <a href="#" tabindex="0" class="btn btn-default" class:disabled={$zoom <= 0.3} on:click={() =>{if ($zoom > 0.3) $zoom /= 1.2}} title={trans("Scale texture down")}><i class="fas fa-th" style="font-size: 16px; padding: 8px;"></i></a>
        <a href="#" tabindex="0" class="btn btn-default" class:disabled={$zoom >= 3} on:click={() => {if ($zoom < 3) $zoom *= 1.2}} title={trans("Scale texture up")}><i class="fas fa-th"></i></a>
    </div>
        {#if hsvSupported}
            <div class="btn-group btn-group-xs " role="group">
                <a href="#" tabindex="0" class="btn btn-default" on:click={() =>{adjustHSV()}}><i class="fas fa-adjust" style="font-size: 16px; padding: 8px;" title={trans("Adjust colors")}></i></a>
            </div>
        {/if}
    {/if}
</div>
